import { createSlice } from '@reduxjs/toolkit';
import { getLegacyColores } from '../legacy/thunk.js';

export const initialState = {
    legacyColores: [],
    loading: false,
    error: {},
};

const legacyColoresSlice = createSlice({
    name: 'legacyColores',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getLegacyColores.fulfilled, (state, action) => {
            state.legacyColores = action.payload;
            state.loading = true;
        });
        builder.addCase(getLegacyColores.rejected, (state, action) => {
            state.error = action.payload.error || null;
            state.loading = true;
        });
        builder.addCase(getLegacyColores.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
    }
});

export default legacyColoresSlice.reducer;